import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ReplaySubject, Subject, Subscription } from 'rxjs';
import { OPD_CONST } from '../../properties/opd-static-properties';
import { OPD_API_URL } from '../../properties/opd-url-properties';
import { MICROSERVICES } from 'projects/lib/medcare-core-lib/src/lib/constants/web-services';
import { AppBaseService } from 'projects/lib/medcare-core-lib/src/lib/services/http.service';

@Component({
  selector: 'app-account-details-dialog',
  templateUrl: './account-details-dialog.component.html',
  styleUrls: ['./account-details-dialog.component.scss']
})
export class AccountDetailsDialogComponent implements OnInit, OnDestroy {
  private unsubscribe: ReplaySubject<boolean> = new ReplaySubject(1);
  private subscriptionList = new Subscription();
  protected _onDestroy = new Subject<void>();
  displayedColumnsAccountDetails: string[] = OPD_CONST.displayedColumnsAccountDetails;
  dataSourceAccountDetails: MatTableDataSource<any> = new MatTableDataSource<any>();
  accountDetails: any[] = [];
  constructor(
    public dialogRef: MatDialogRef<AccountDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private appBaseService: AppBaseService,
  ) { }

  ngOnInit(): void {
    this.getPayerDetails(this.data);
  }

  /**
   * closing dialog
   */
  onClick() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
    this._onDestroy.next();
    this._onDestroy.complete();
    this.subscriptionList.unsubscribe();
  }

  /**
   * 
   * @param rowData 
   */
  getPayerDetails(rowData) {
    this.data = rowData;
    this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.GET_PAYER_DETAILS + this.data.id)
      .subscribe((response) => {
        if (response) {
          this.accountDetails = response;
          this.dataSourceAccountDetails = new MatTableDataSource<any>(this.accountDetails);
        }
      });
  }

}
